import { useSnapshot } from 'valtio';
import { UserStore } from '../stores/user-roles-store';
import { RoleName } from '../types/user-role-types';

export const useUserAdminRole = (): boolean => {
  const userRoles = useSnapshot(UserStore);

  // BC support for no user roles is admin
  if (!userRoles.roles) {
    return true;
  }

  return userRoles.roles.includes(RoleName.Admin);
};

export const useIsUserReadOnlyRole = (): boolean => {
  const userRoles = useSnapshot(UserStore);

  // BC support for no user roles is admin
  if (!userRoles.roles) {
    return false;
  }

  return !userRoles.roles.includes(RoleName.Admin);
};
